import { useEffect, useRef, useState } from 'react';

export function LiveScanCounter({ value }: { value: number }) {
  const [pulse, setPulse] = useState(false);
  const previousValue = useRef(value);

  useEffect(() => {
    if (value !== previousValue.current) {
      previousValue.current = value;
      setPulse(true);
      const timeout = setTimeout(() => setPulse(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [value]);

  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-6)',
        textAlign: 'center',
        marginBottom: 'var(--space-6)',
        transition: 'transform 0.2s ease',
        transform: pulse ? 'scale(1.02)' : 'scale(1)'
      }}
    >
      <div
        className="font-display"
        style={{ fontSize: '3.5rem', fontWeight: 700, color: pulse ? 'var(--accent)' : 'var(--text)', lineHeight: 1 }}
      >
        {value.toLocaleString()}
      </div>
      <div style={{ color: 'var(--text-muted)', marginTop: 'var(--space-2)' }}>Live scan count</div>
    </div>
  );
}
